import { z } from 'zod'

export const schema = z.object({
  closedDates: z.array(z.string()),
})

export type schemaType = z.infer<typeof schema>
